import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { ICachedProgramType } from '../models'

export const getProgramTypeCacheStore = (): Crud<ICachedProgramType> =>
  CrudStore.get(CrudStoreItemPartner360.ProgramTypeCacheStore, 'programTypeCacheStore')
